<a href="{{network?.explorer}}/{{type}}/{{link}}" target="_blank">{{text ? text : link}}</a>